import { render, staticRenderFns } from "./UpdateOrgUser.vue?vue&type=template&id=7a56d93c&"
import script from "./UpdateOrgUser.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgUser.vue"
export default component.exports